"use client";

import { createContext } from "react";
import { StrapiCollectionType, StrapiSingleType } from "@/src/type";

export interface CMSContextType {
  webConfig: StrapiSingleType.WebConfig | undefined;
  locale: string;
  direction: string;
  propertySlug: string | undefined;
  galleries?: StrapiCollectionType.Gallery[];
  constructLink: (path: string, overrideLocal?: string | null, propertySlug?: string) => string;
  changeLocale: (locale: string) => string;
}

export const CMSContext = createContext<CMSContextType>({
  webConfig: undefined,
  locale: "en",
  direction: "ltr",
  propertySlug: undefined,
  galleries: undefined,
  constructLink: () => {
    return "";
  },
  changeLocale: () => {
    return "";
  },
});
